(function () {
    angular
        .module('app')
        .controller('StorageEditorController', StorageEditorController);

    // Define controller dependencies.
    StorageEditorController.$inject = ['$q', '$rootScope', '$scope', 'Restangular', 'SanitizerFactory'];

    /**
     * Controller for 'editor' view of 'master.storage' state.
     *
     * @param $q
     * @param $rootScope
     * @param $scope
     * @param Restangular
     * @param SanitizerFactory
     * @constructor
     */
    function StorageEditorController($q, $rootScope, $scope, Restangular, SanitizerFactory) {
        /**
         * --------------------------------------------
         * Private variables.
         * --------------------------------------------
         */

        /**
         * This controller.
         */
        var vm = this;

        /**
         * --------------------------------------------
         * Bindable members.
         * --------------------------------------------
         */

        /**
         * Bindable properties.
         */
        vm.applicationValues = undefined;
        vm.readOnlyValues = undefined;
        vm.updateOnlyValues = undefined;
        vm.backupValues = undefined;
        vm.activeValues = undefined;

        /**
         * Bindable methods.
         */
        vm.setApplicationValues = setApplicationValues;

        /**
         * --------------------------------------------
         * Private methods.
         * --------------------------------------------
         */

        /**
         * Initialize editor's data source.
         *
         * @returns Promise
         */
        function initialize() {
            $scope.shared.editor.initialized = false;

            vm.applicationValues = undefined;
            vm.readOnlyValues = undefined;
            vm.backupValues = undefined;
            vm.activeValues = undefined;

            return $q.when()
                .then(setReadOnlyValues)
                .then(setUpdateOnlyValues)
                .then(setBackupValues)
                .then(setActiveValues)
                .then(function () {
                    $scope.shared.editor.initialized = true;
                })
                .catch(function () {
                    return $q.reject();
                });

            function getResourceFieldValues(field) {
                return _.get(_.find($rootScope.global.resourceFields.storage, {'name': field}), 'values');
            }

            function setReadOnlyValues() {
                vm.readOnlyValues = getResourceFieldValues('read_only');
                return $q.when();
            }

            function setUpdateOnlyValues() {
                vm.updateOnlyValues = getResourceFieldValues('update_only');
                return $q.when();
            }

            function setBackupValues() {
                vm.backupValues = getResourceFieldValues('backup');
                return $q.when();
            }

            function setActiveValues() {
                vm.activeValues = getResourceFieldValues('active');
                return $q.when();
            }
        }

        /**
         * Set default value for new resource.
         */
        function setNew() {
            if ($scope.shared.editor.initialized) {
                $scope.shared.editor.entity = {
                    id: undefined,
                    application_id: '',
                    name: '',
                    driver: '',
                    host: '',
                    database: '',
                    username: '',
                    password: '',
                    read_only: vm.readOnlyValues[0].value,
                    update_only: vm.updateOnlyValues[0].value,
                    backup: vm.backupValues[1].value,
                    active: vm.activeValues[1].value
                };
            }
        }

        /**
         * --------------------------------------------
         * Bindable member implementations.
         * --------------------------------------------
         */

        /**
         * Set application values.
         */
        function setApplicationValues() {
            vm.applicationValues = undefined;
            return Restangular.all('application').getList({q: {
                s: [{f: 'id'}, {f: 'code'}],
                o: [{f: 'code', o: 'asc'}]
            }})
                .then(function (result) {
                    vm.applicationValues = SanitizerFactory.sanitizeReceived(result.original);
                });
        }

        /**
         * --------------------------------------------
         * Controller activation.
         * --------------------------------------------
         */

        /**
         * Activate controller.
         */
        function activate() {
            $scope.shared.editor.initialize = initialize;
            $scope.shared.editor.setNew = setNew;

            $scope.$on('CRUDFactory.editSuccess', function (event, entity) {
                vm.applicationValues = [entity.application];
            });
        }

        activate();
    }
})();
